import {
  DestroyRef,
  Injectable,
  WritableSignal,
  afterNextRender,
  inject,
  signal,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SearchRepository } from '@core/services/repositories/search.repository';
import { WebengageService } from '@core/services/webengage.service';
import { BehaviorSubject } from 'rxjs';
import { AutocompleteService } from './autocomplete.service';

@Injectable({
  providedIn: 'root',
})
export class SearchBoxService {
  /*
            - inject
        */
  searchRepo = inject(SearchRepository);
  router = inject(Router);
  destroyRef = inject(DestroyRef);
  route = inject(ActivatedRoute);
  isShabAdsCode = signal(false);
  noSearchResult = signal(false);
  webengageService = inject(WebengageService);
  public _openCalander: WritableSignal<boolean | any> = signal(null);
  public showFiltersSideNav: WritableSignal<boolean> = signal(false);
  public isSearch: WritableSignal<boolean> = signal(false);

  accommodation: WritableSignal<string> = signal('');

  mobileSearchBoxIsOpen = new BehaviorSubject<boolean>(false);

  searchTrigger: WritableSignal<boolean> = signal(false);
  dateRange: Array<string> = [];
  residentType: 1 | 2 | 3 | 4 | 5 | 6 = 1;
  residentKeyForPayload?: string;
  residentId?: number;
  residentName = '';
  urlToRedirect = '';
  constructor() {
    this.accommodation.set(this.router.routerState.snapshot.url.split('/')[1]);
    afterNextRender(() => {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.accommodation.set(
            this.router.routerState.snapshot.url.split('/')[1] == 'ecolodge' ? 'ecolodge' : '/'
          );
        }
      });
    });
  }
  getStartAndEndDate(): Array<string> {
    if (this.dateRange?.length)
      return [this.dateRange[0], this.dateRange[this.dateRange?.length - 1]];
    else {
      return ['', ''];
    }
  }

  triggerSearch(event: any, rerender = false, adCode: boolean) {
    this.isSearch.set(true);
    let startDate: string = '';
    let endDate: string = '';
    this.residentId = event.id;
    this.residentType = event.type;
    this.residentKeyForPayload = this.getResidentTypeName();
    this.urlToRedirect = event.link;
    this.residentName = event.name;
    if (event.startDate !== '' && event.endDate !== '') {
      startDate = event.startDate;
      endDate = event.endDate;
      this.dateRange = [event.startDate, event.endDate];
    } else {
      startDate = this.getStartAndEndDate()[0];
      endDate = this.getStartAndEndDate()[1];
    }
    const residentTypeKey = this.getResidentTypeName();
    let queryParams = {
      minPrice: null,
      maxPrice: null,
      labels: null,
      types: null,
      grades: null,
      reviews: null,
      date: startDate,
      endDate: endDate,
      type: String(this.residentType),
    };
    if (residentTypeKey) {
      (queryParams as any)[residentTypeKey] = String(this.residentId);
    }

    this.isShabAdsCode.set(event.isShabAdsCode);
    this.router
      .navigate(
        [
          this.accommodation() == 'ecolodge' && !event?.isShabAdsCode && !this.noSearchResult()
            ? '/ecolodge/' + event.name :
          this.noSearchResult() ? 'ecolodge/search' 

              : this.urlToRedirect,
        ],
        {
          queryParams: {
            search_box: this.residentName || null,
            refer: 'home',
            ...queryParams,
          },
          preserveFragment: false,
        }
      )

      
      .finally(() => {
        // this.autoCompleteService.adCode.set(false);
        
        this.isSearch.set(false);
      });
  }

  getResidentTypeName() {
    let residentTypeKey = '';
    if (this.residentType === 1) residentTypeKey = 'cityId';
    else if (this.residentType === 2) residentTypeKey = 'region';
    else if (this.residentType === 3) residentTypeKey = 'hid';
    else if (this.residentType === 4) residentTypeKey = 'district';
    else if (this.residentType === 5) residentTypeKey = 'state';
    return residentTypeKey;
  }

  getCurrentDate() {
    return this.searchRepo.getCurrentDate();
  }

  getHolidays(range: { StartDate: string; EndDate: string }) {
    return this.searchRepo.getHolidays(range);
  }
}
